import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import styled from 'styled-components';
import { useIsMobile } from '../../style/constants';
import { Col, Row } from '../../VuexyDesign/atoms/_index';
import DistributionButton from './DistributionButton';

function DistributionProInfo() {
  const isMobile = useIsMobile();
  const { t } = useTranslation('distributionLanding');

  return (
    <DistributionProInfoWrapper>
      <Row
        className={`d-flex align-items-center justify-content-center mx-auto gradient-box ${
          isMobile ? 'w-100 px-2 py-3' : 'w-100 px-3 py-5'
        }`}
      >
        <Col className="text-center text-white ">
          <h3
            className={`custom-heading-font-3 ${
              isMobile
                ? 'text-white'
                : 'text-white w-75 align-items-center d-flex flex-column text-center mx-auto'
            } `}
          >
            {t('distributionLanding:startDistributing')}
          </h3>
          <p
            className={`custom-font-text-regular-normal mt-1 d-block text-white  ${
              isMobile ? 'w-100' : 'w-75'
            } align-items-center d-flex flex-column text-center mx-auto`}
          >
            {t('distributionLanding:dontWaitAnyLonger')}
          </p>

          <p
            className={`custom-font-text-regular-normal my-1 d-block text-white ${
              isMobile ? 'w-100' : 'w-75'
            } align-items-center d-flex flex-column text-center mx-auto`}
          >
            {t('distributionLanding:virppDistributionServiceHelps')}
          </p>

          <DistributionButton
            type="GET_STARTED_WHITE"
            text={t('distributionLanding:getStarted') as string}
          />
        </Col>
      </Row>
    </DistributionProInfoWrapper>
  );
}

const DistributionProInfoWrapper = styled.div`
  .gradient-box {
    border-radius: 20px;
    background: linear-gradient(315.97deg, #1159f1 1.64%, #f41657 100%);
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
  }
`;

export default DistributionProInfo;
